import { ProcessedRow } from '@import/interfaces/processed-row.interface';

/**
 * Some functions for checking stuff on processed rows
 */
export const getRowErrorCount: (row: ProcessedRow) => number = (row: ProcessedRow) =>
    row.errors ? Object.keys(row.errors).length : 0;
export const getErrorRows: (rows: ProcessedRow[]) => ProcessedRow[] = (rows: ProcessedRow[]) =>
    rows.filter((r: ProcessedRow) => !!getRowErrorCount(r));
export const hasValidationErrors: (rows: ProcessedRow[]) => boolean = (rows: ProcessedRow[]) =>
    !!getErrorRows(rows).length;

export function getColumnValueFromRow(row: ProcessedRow, index: number): string {
    return row.raw[index];
}

export function getColumnValuesFromRows(rows: ProcessedRow[], index: number): string[] {
    return rows.map((row: ProcessedRow) => row.raw[index]);
}
